/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateUserTagOptions,
  UpdateUserTagStatus200,
  UpdateUserTagStatus400,
  UpdateUserTagStatus401,
  UpdateUserTagStatus404,
  UpdateUserTagStatus500,
} from '../types/UpdateUserTag'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateUserTag } from '../clients/updateUserTag'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateUserTagMutationKey = () => [{ url: '/v1/user/:user_id/tag' }] as const

export function updateUserTagMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateUserTagMutationKey()
  return mutationOptions<
    UpdateUserTagStatus200,
    ResponseErrorConfig<
      | UpdateUserTagStatus400
      | UpdateUserTagStatus401
      | UpdateUserTagStatus404
      | UpdateUserTagStatus500
    >,
    UpdateUserTagOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateUserTag({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Updates the user's tag list with the given tags. MARKET_MAKER-tagged users are exempt from the tenant trade limit and asset position restriction on POST /v1/orders.
 * @summary Update a user's tag list (admin-only)
 * {@link /v1/user/:user_id/tag}
 */
export function useUpdateUserTag<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateUserTagStatus200,
      ResponseErrorConfig<
        | UpdateUserTagStatus400
        | UpdateUserTagStatus401
        | UpdateUserTagStatus404
        | UpdateUserTagStatus500
      >,
      UpdateUserTagOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateUserTagMutationKey()

  const baseOptions = updateUserTagMutationOptions(config) as UseMutationOptions<
    UpdateUserTagStatus200,
    ResponseErrorConfig<
      | UpdateUserTagStatus400
      | UpdateUserTagStatus401
      | UpdateUserTagStatus404
      | UpdateUserTagStatus500
    >,
    UpdateUserTagOptions,
    TContext
  >

  return useMutation<
    UpdateUserTagStatus200,
    ResponseErrorConfig<
      | UpdateUserTagStatus400
      | UpdateUserTagStatus401
      | UpdateUserTagStatus404
      | UpdateUserTagStatus500
    >,
    UpdateUserTagOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateUserTagStatus200,
    ResponseErrorConfig<
      | UpdateUserTagStatus400
      | UpdateUserTagStatus401
      | UpdateUserTagStatus404
      | UpdateUserTagStatus500
    >,
    UpdateUserTagOptions,
    TContext
  >
}
